module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.530dd226.jpeg";